import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Link from 'next/link';

/**
 *
 * links = [{
 *  label:text,
 *  url: text
 * }]
 */

const Breadcrumb = ({ links = [] }) => (
  <nav className="im-breadcrumb" aria-label="breadcrumb">
    <ol className="breadcrumb">
      {_.map(links, (link, index) => (
        <li className="breadcrumb-item" key={index}>
          <Link href={link.url}>
            <a>{link.label}</a>
          </Link>
        </li>
      ))}
    </ol>
  </nav>
);

Breadcrumb.propTypes = {
  links: PropTypes.array,
};

export default Breadcrumb;
